// Generated by Claude Code
import { createFileRoute } from '@tanstack/react-router'
import { WorkOrdersAnalyticsPage } from '#components/domain/operations/analytics/work-orders/work-orders-analytics-page.tsx'

export const Route = createFileRoute('/_app/$companyId/analytics/work-orders')({
  component: WorkOrdersAnalyticsPage,
  staticData: { title: 'Analysis', appShell: true },
})
